module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M30.156 0H2.01C.904 0 0 1.021 0 2.151v22.07c0 1.13.905 1.914 2.01 1.914h2.01v4.777c0 1.134.812 1.325 1.813.834l10.812-5.611h13.51c1.106 0 2.01-.784 2.01-1.914V2.151c0-1.13-.905-2.151-2.01-2.151z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/comment-2.js
// module id = 1082
// module chunks = 14